export default __webpack_public_path__ + "static/media/TheElements _16.76748073.png";